import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { tokens } from "../../components/Theme";
import DeleteOperationById from "../../api/operation/DeleteOperationById";
import GetOperationById from "../../api/operation/GetOperationById";
import CreateWateringOperation from "../../api/operation/CreateWateringOperation";
const initialPayload = [
  {
    appCropId: "20240625",
    appOperId: "2025",
    operDate: "2025-06-26",
    startTime: "08:00",
    endTime: "10:00",
    wateringSystem: "สปริงเกอร์",
    waterAmount: 1000,
  },
];

export default function WateringTable({ appCropId }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [waterings, setWaterings] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (appCropId) {
        try {
          const res = await GetOperationById({ appCropId, appOperId: "OA" });
          setWaterings(res);
        } catch (err) {
          console.error("Error fetching fertilizer stock:", err);
        }
      }
    };
    fetchData();
  }, [appCropId]);

  const handleChange = (index, key, value) => {
    const updated = [...waterings];
    updated[index][key] = value;
    setWaterings(updated);
  };

  const handleAdd = () => {
    const timestamp = Math.floor(Date.now() / 1000);
    setWaterings([
      ...waterings,
      {
        appCropId,
        appOperId: "OA" + timestamp,
        operDate: "",
        startTime: "",
        operDate: "",
        endTime: "",
        wateringSystem: "",
        waterAmount: "",
      },
    ]);
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleDelete = (index) => {
    setWaterings(waterings.filter((_, i) => i !== index));
  };
  const openDeleteDialog = (id) => {
    setSelectedDeleteId(id);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await DeleteOperationById({ appOperId: selectedDeleteId });
      setWaterings((prev) =>
        prev.filter((item) => item.appOperId !== selectedDeleteId)
      );
      setSnackbarSeverity("success");
      setSnackbarMessage("ลบรายการสำเร็จ");
    } catch (err) {
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาดในการลบ");
    } finally {
      setDeleteDialogOpen(false);
      setOpenSnackbar(true);
    }
  };
  const handleSave = async () => {
    // console.log("Result:", JSON.stringify(waterings, null, 2));
    const results = await CreateWateringOperation(waterings);
    const hasError = results.some((r) => r.status !== 200);
    if (hasError) {
      setSnackbarSeverity("error");
      setSnackbarMessage("บางรายการบันทึกไม่สำเร็จ");
    } else {
      setSnackbarSeverity("success");
      setSnackbarMessage("บันทึกสำเร็จทั้งหมด");
    }
    setOpenSnackbar(true);
  };

  return (
    <Box p={2}>
      <Box
        width="100%"
        sx={{ backgroundColor: colors.greenAccent[300] }}
        display="flex"
        justifyContent="center"
      >
        <Typography
          p={isMobile ? 1 : 2}
          variant={isMobile ? "body" : "h6"}
          fontWeight="bold"
          color="#fff"
        >
          ตารางการให้น้ำ
        </Typography>
      </Box>
      <Box maxWidth={isMobile ? "320px" : "none"}>
        <TableContainer
          component={Paper}
          sx={{
            mt: 2,
            overflowX: isMobile ? "auto" : "visible",
          }}
        >
          <Table size="small" sx={{ minWidth: isMobile ? 600 : "auto" }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>#</strong>
                </TableCell>
                <TableCell>
                  <strong>วันที่</strong>
                </TableCell>
                <TableCell>
                  <strong>เริ่มเวลา</strong>
                </TableCell>
                <TableCell>
                  <strong>สิ้นสุดเวลา</strong>
                </TableCell>
                <TableCell>
                  <strong>ระบบการให้น้ำ</strong>
                </TableCell>
                <TableCell>
                  <strong>ปริมาณน้ำ (ลิตร)</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>ลบ</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {waterings.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={row.operDate}
                      onChange={(e) =>
                        handleChange(index, "operDate", e.target.value)
                      }
                    />
                  </TableCell>

                  <TableCell>
                    <TextField
                      type="time"
                      size="small"
                      value={row.startTime}
                      onChange={(e) =>
                        handleChange(index, "startTime", e.target.value)
                      }
                    />
                  </TableCell>

                  <TableCell>
                    <TextField
                      type="time"
                      size="small"
                      value={row.endTime}
                      onChange={(e) =>
                        handleChange(index, "endTime", e.target.value)
                      }
                    />
                  </TableCell>

                  <TableCell
                    sx={{
                      minWidth: isMobile ? "150px" : "auto",
                    }}
                  >
                    <TextField
                      size="small"
                      value={row.wateringSystem}
                      onChange={(e) =>
                        handleChange(index, "wateringSystem", e.target.value)
                      }
                    />
                  </TableCell>

                  <TableCell
                    sx={{
                      minWidth: isMobile ? "100px" : "auto",
                    }}
                  >
                    <TextField
                      type="number"
                      size="small"
                      value={row.waterAmount}
                      onChange={(e) =>
                        handleChange(index, "waterAmount", e.target.value)
                      }
                    />
                  </TableCell>

                  <TableCell align="center">
                    <IconButton
                      color="error"
                      onClick={() => openDeleteDialog(row.appOperId)}  // ใช้ ID ของรายการ
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              <TableRow>
                <TableCell colSpan={7} align="center">
                  <IconButton onClick={handleAdd} variant="outlined">
                    <AddIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box textAlign="center" mt={3}>
        <Button
          variant="contained"
          sx={{ backgroundColor: colors.greenAccent[400] }}
          onClick={handleSave}
        >
          บันทึกข้อมูล
        </Button>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            justifyContent: "center",
            minWidth: "200px",
            textAlign: "center",
          },
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>ยืนยันการลบ</DialogTitle>
        <DialogContent>
          <Typography>คุณต้องการลบรายการนี้ใช่หรือไม่?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>ยกเลิก</Button>
          <Button color="error" onClick={confirmDelete}>
            ลบ
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}





